import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TreeNode } from 'ui-library';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIcon,
    TranslateModule,
    RouterLink,
    MatDivider
  ],
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})

export class MenuItemComponent implements OnInit {
  @Input() item!: TreeNode;
  @Input() fromSide: boolean = false;

  multiline: boolean = false;

  ngOnInit(): void {
    if (this.item.name?.length >= 25)
      this.multiline = true;
  }

}